import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { rootPaths } from 'routes/paths';
import DashboardPage from 'features/dashboard/pages/DashboardPage';
import { SendSingleGiftPage } from 'features/dashboard/pages/SendSingleGiftPage';
import SendGiftInBulk from 'features/dashboard/pages/SendGiftInBulk';

import { dashboardPaths } from './paths';

export const DashboardRouter = () => {
  return (
    <Switch>
      <Route exact path={dashboardPaths.static.root} component={DashboardPage} />
      <Route exact path={dashboardPaths.static.sendSingleGift} component={SendSingleGiftPage} />
      <Route exact path={dashboardPaths.static.sendGiftInBulk} component={SendGiftInBulk} />
      <Route>
        <Redirect to={rootPaths.static.notFound} />
      </Route>
    </Switch>
  );
};
